import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { Link } from "react-router-dom";

import {
    getInputCapacity,
    getOutletPressure,
    getCoolingTypes
} from "../../constants/sizing-constant";

export default class AirCentrifugeSizing extends Component {

    state = {
        inputCapacity: [],
        outletPressure: [],
        coolingTypes: [],
        selectedInputCapacity: "0",
        selectedOutletPressure: "0",
        selectedCoolingType: "0",
        suggestedModel: "",
        suggestedModelId: "",
        sentrifuge: []
    };

    componentDidMount() {
        this.setState({ inputCapacity: [...getInputCapacity()] });
        this.setState({ outletPressure: [...getOutletPressure()] });
        this.setState({ coolingTypes: [...getCoolingTypes()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handleInputCapacity = inputCapacity => {
        if (inputCapacity) {
            this.setState({ selectedInputCapacity: inputCapacity.value }, () => {
                this.findModel();
            });
        }
    };

    handleOutletPressure = outletPressure => {
        if (outletPressure) {
            this.setState({ selectedOutletPressure: outletPressure.value }, () => {
                this.findModel();
            });
        }
    };

    handleCoolingTypesSelect = coolingType => {
        if (coolingType) {
            this.setState({ selectedCoolingType: coolingType.value }, () => {
                this.findModel();
            });
        }
    }

    findModel() {
        const selectedInputCapacity = this.state.selectedInputCapacity;
        const selectedCoolingType = this.state.selectedCoolingType;
        const selectedOutletPressure = this.state.selectedOutletPressure;
        if (selectedInputCapacity === "1") {
            this.setState({ suggestedModel: "درخواست شما یافت نشد ممکن است نیاز به سفارش ساخت خاص باشد . لطفا با واحد فروش تماس بگیرید." });
            const suggestedProducts = []
            this.props.handler(suggestedProducts)
            return;
        }
        if (selectedInputCapacity === "2") {
            if (selectedOutletPressure === "0" || selectedOutletPressure === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYTC400" });
                    this.setState({ suggestedModelId: "1" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYTC400-AC" });
                    this.setState({ suggestedModelId: "7" });
                }
                else {
                    this.setState({ suggestedModel: "HYTC400 یا HYTC400-AC" });
                    this.setState({ suggestedModelId: "85" });
                }
            }
            else {
                this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." });
            }
        }
        if (selectedInputCapacity === "3") {
            if (selectedOutletPressure === "0" || selectedOutletPressure === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYTC500" });
                    this.setState({ suggestedModelId: "2" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYTC500-AC" });
                    this.setState({ suggestedModelId: "8" });
                }
                else {
                    this.setState({ suggestedModel: "HYTC500 یا HYTC500-AC" });
                    this.setState({ suggestedModelId: "86" });
                }
            }
            else {
                this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." });
            }
        }
        if (selectedInputCapacity === "4") {
            if (selectedOutletPressure === "0" || selectedOutletPressure === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYTC600" });
                    this.setState({ suggestedModelId: "3" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYTC600-AC" });
                    this.setState({ suggestedModelId: "9" });
                }
                else {
                    this.setState({ suggestedModel: "HYTC600 یا HYTC600-AC" });
                    this.setState({ suggestedModelId: "87" });
                }
            }
            else {
                this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." });
            }
        }
        if (selectedInputCapacity === "5") {
            if (selectedOutletPressure === "0" || selectedOutletPressure === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYTC700" });
                    this.setState({ suggestedModelId: "4" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYTC700-AC" });
                    this.setState({ suggestedModelId: "10" });
                }
                else {
                    this.setState({ suggestedModel: "HYTC700 یا HYTC700-AC" });
                    this.setState({ suggestedModelId: "88" });
                }
            }
            else {
                this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." });
            }
        }
        if (selectedInputCapacity === "6") {
            if (selectedOutletPressure === "0" || selectedOutletPressure === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYTC800" });
                    this.setState({ suggestedModelId: "5" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYTC800-AC" });
                    this.setState({ suggestedModelId: "11" });
                }
                else {
                    this.setState({ suggestedModel: "HYTC800 یا HYTC800-AC" });
                    this.setState({ suggestedModelId: "89" });
                }
            }
            else {
                this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." });
            }
        }
        if (selectedInputCapacity === "7") {
            if (selectedOutletPressure === "0" || selectedOutletPressure === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HYTC900" });
                    this.setState({ suggestedModelId: "6" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HYTC900-AC" });
                    this.setState({ suggestedModelId: "12" });
                }
                else {
                    this.setState({ suggestedModel: "HYTC900 یا HYTC900-AC" });
                    this.setState({ suggestedModelId: "90" });
                }
            }
            else {
                this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." });
            }
        }
        if (selectedInputCapacity === "8") {
            this.setState({ suggestedModel: "برای انتخاب مدل مناسب در این مورد با بخش فروش تماس بگیرید." }
            );
        }
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.inputCapacity}
                    placeholder="ظرفیت ورودی کمپرسور (برحسب مترمکعب بر ساعت)"
                    onItemSelect={this.handleInputCapacity}
                />
                <DropDownWhiteStyle
                    items={this.state.outletPressure}
                    placeholder="فشار خروجی کمپرسور (برحسب بار نسبی)"
                    onItemSelect={this.handleOutletPressure}
                />
                <DropDownWhiteStyle
                    items={this.state.coolingTypes}
                    placeholder="نوع خنک کننده"
                    onItemSelect={this.handleCoolingTypesSelect}
                />
                {this.state.suggestedModel !== "" &&
                    <Fragment>
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
